<template>
  <div>
    <v-autocomplete
      v-if="$getLoggedUser().has_ecommerce"
      v-model="productForms.brandId"
      item-text="name"
      item-value="id"
      :items="items"
      label="Marca"
      outlined
      color="#C3C8CD"
      height="44px"
      :disabled="!userHasPermission"
      :loading="isLoading"
      :search-input.sync="search"
    />
  </div>
</template>

<script>
import { QUERY_GET_BRANDS } from '@/modules/produtos/gerenciamento-produtos/graphql'

export default {
  name: 'SearchBrands',
  inject: ['userHasPermission'],
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    isLoading: false,
    search: '',
    pagination: {
      page: 1,
      pageSize: 100000,
    },
    items: [],
  }),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    search(val) {
      if (this.isLoading) return

      this.getBrands()
    },
  },
  mounted() {
    this.getBrands()
  },
  methods: {
    getBrands() {
      this.isLoading = true

      this.$apollo
        .query({
          query: QUERY_GET_BRANDS,
          variables: { ...this.pagination, search: this.search },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { brands } }) => {
          this.items = brands.brands
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao carregar as marcas', snackbarColor: 'error' })
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<style lang="scss"></style>
